export default "__VITE_ASSET__ChZa_yeu__"